"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function on(emitter, event, fn) {
    emitter.on(event, fn);
    return {
        destroy: function () { return emitter.off(event, fn); },
    };
}
exports.default = on;
//# sourceMappingURL=on.js.map